// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"45":"0abe93a8","787":"6f347169","802":"14d71545"}[chunkId] + ".chunk.js";
};